// bd-deepcontext-b4zw — the SSE line framing that was inlined in
// ScheduledJobs.handleShowRuns. Split out so the buffering rules (partial lines
// across reads, event name applying to the next data payload and resetting
// afterwards, unparseable payloads skipped) are unit-testable without a network.
// Promoted to hooks/ (bd-deepcontext-ioq0) so useEventStream can share it as
// generic fetch-SSE infrastructure, not something scoped to scheduled jobs.

export interface SseEvent {
  event: string;
  data: any;
}

export interface SseParser {
  /** Feed a decoded chunk; returns the events completed by it, in order. */
  push(chunk: string): SseEvent[];
}

export const createSseParser = (): SseParser => {
  let buffer = "";
  let currentEvent = "";

  return {
    push(chunk: string): SseEvent[] {
      const events: SseEvent[] = [];
      buffer += chunk;
      const lines = buffer.split("\n");
      buffer = lines.pop() || "";

      for (const line of lines) {
        if (line.startsWith("event: ")) {
          currentEvent = line.substring(7).trim();
          continue;
        }

        if (line.startsWith("data: ")) {
          const dataString = line.substring(6).trim();
          if (dataString) {
            try {
              const data = JSON.parse(dataString);
              events.push({ event: currentEvent, data });
              // Reset event after processing
              currentEvent = "";
            } catch (parseError) {
              console.error("Failed to parse SSE data:", parseError);
            }
          }
        }
      }

      return events;
    },
  };
};
